import axios from "axios";

const API = axios.create({
  baseURL: "https://peter-magagaweb.onrender.com/api/",
});

export const getProjects = () => API.get("projects/");
export const getProjectBySlug = (slug) => API.get(`projects/${slug}/`);
export const getExperience = () => API.get("experience/");
export const sendContactMessage = (data) =>
  API.post("contact/", data);
export const getBlogPosts = () => API.get("blog/");

export const getBlogPostBySlug = (slug) =>
  API.get(`blog/${slug}/`);